import { api } from '../api'

const API = 'MediaUploads'

const API_MEDIA_UPLOADS = {
  UPLOAD_FILE: `${API}/UploadFileToCloud`,
  REMOVE_FILE: ({ filePath }) =>
    `${API}/RemoveFileFromCloud?filePath=${encodeURIComponent(filePath)}`
}

class ModuleService {
  async uploadFile ({ fileName, content, filePath }) {
    return api.post(API_MEDIA_UPLOADS.UPLOAD_FILE, { fileName, content, filePath })
  }
  async removeFile ({ filePath }) {
    return api.put(API_MEDIA_UPLOADS.REMOVE_FILE({ filePath }))
  }
}

export const ServiceMediaUploads = new ModuleService()
